import PausedPeriod from './paused-period-view'
export default PausedPeriod
